import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Icon, type IconName} from '@wandb/weave/components/Icon';
import classNames from 'classnames';
import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback} from 'react';

interface CopyableTextProps {
  className?: string;
  dataTest?: string;
  text: string;
  copyText?: string;
  toastText: string;
  icon?: IconName;
  code?: boolean;
  disabled?: boolean;
  onClick?(): void;
}

const CopyableText: React.FC<CopyableTextProps> = React.memo(
  ({
    className,
    dataTest,
    text,
    copyText,
    toastText,
    icon,
    code,
    disabled,
    onClick,
  }) => {
    const copy = useCallback(() => {
      copyToClipboard(copyText ?? text);
      toast(toastText);
    }, [text, copyText, toastText]);

    return (
      <span
        className={classNames('copyable-text', className, {code, disabled})}
        data-test={dataTest}
        onClick={e => {
          e.stopPropagation();
          if (disabled) {
            return;
          }
          copy();
          onClick?.();
        }}>
        <span className="copyable-text-content">{text}</span>
        <Icon className="copy-icon" name={icon ?? 'copy'} />
      </span>
    );
  }
);
CopyableText.displayName = 'CopyableText';

export default CopyableText;
